<template>
  <div class="massive-template-download-card">
    <v-card class="template-card" outlined elevation="2">
      <v-card-text class="pa-6">
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-icon size="48" color="deep-purple darken-1" class="mr-4">mdi-file-download</v-icon>
            <div>
              <div class="text-h6 font-weight-medium mb-1">{{ computedTitle }}</div>
              <div class="text-body-2 text--secondary">
                {{ computedDescription }}
              </div>
            </div>
          </div>
          <v-btn
            color="primary"
            outlined
            @click="$emit('download')"
            class="ml-4"
          >
            <v-icon left>mdi-download</v-icon>
            {{ $t('massive.templateDownload.title') }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'MassiveTemplateDownloadCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    computedTitle() {
      return this.title || this.$t('massive.templateDownload.title');
    },
    computedDescription() {
      return this.description || this.$t('massive.templateDownload.description');
    }
  }
};
</script>

<style lang="css" scoped>
.massive-template-download-card {
  margin-bottom: 24px;
}

.template-card {
  border-left: 4px solid var(--v-primary-base);
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.template-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.template-card .text-h6 {
  word-break: break-word;
  line-height: 1.3;
}

.template-card .text-body-2 {
  word-break: break-word;
  line-height: 1.4;
}
</style>
